<h2 mat-dialog-title>{{ 'forgot-password' | translate }}</h2>
<form [formGroup]="formGroup"
      (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{ 'username' | translate }}</mat-label>
      <input matInput
             type="text"
             class="form-control"
             spellcheck="false"
             required
             autofocus
             formControlName="username" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" color="primary" mat-raised-button [disabled]="!formGroup.valid">
      {{ 'submit-btn' | translate }}
    </button>
    <button mat-raised-button mat-dialog-close>
      {{ 'cancel' | translate }}
    </button>
  </mat-dialog-actions>
</form>
